import { Api as DataApi } from '@robovision/data'
import { Api as HubApi } from '@robovision/hub'
import { Api as ImportExportApi } from '@robovision/import-export'
import { Api as MetricsApi } from '@robovision/metrics'
import { Api as NotificationsApi } from '@robovision/notification-center'
import { Api as RvaiAuthApi } from '@robovision/rvai-auth'


function getAbsoluteEnvUrl (path: string): string {
  return `${location.origin}${path}`
}

export const dataApi = new DataApi({
  baseURL: getAbsoluteEnvUrl('/datastore/api/v1'),
})

export const hubApi = new HubApi({
  baseURL: getAbsoluteEnvUrl('/hub/api/v1'),
})

export const importExportApi = new ImportExportApi({
  baseURL: getAbsoluteEnvUrl('/io/api/v1'),
})

export const metricsApi = new MetricsApi({
  baseURL: getAbsoluteEnvUrl('/metrics/api/v1'),
})

export const notificationsApi = new NotificationsApi({
  baseURL: getAbsoluteEnvUrl('/nc/api/v1'),
})

export const rvaiAuthApi = new RvaiAuthApi({
  baseURL: getAbsoluteEnvUrl('/auth/api/v1'),
})
